import {
  useInfiniteData,
  UseInfiniteDataProps,
} from '@common/ui/infinite-scroll/use-infinite-data';
import {Track} from '@app/web-player/tracks/track';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export const libraryTracksQueryKey = (
  userId: number | 'me',
  queryParams?: Record<string, string | number>,
) => {
  const user = getBootstrapData().user;
  // make sure we are using "me" as ID for current user
  // everywhere, so it's easier to invalidate queries
  if (userId === user?.id) {
    userId = 'me';
  }
  const key: any[] = ['tracks', 'library', userId];
  if (queryParams) {
    key.push(queryParams);
  }
  return key;
};

export function useUserLikedTracks(
  userId: number | 'me',
  options?: Partial<UseInfiniteDataProps<Track>>,
) {
  const queryParams = options?.queryParams;
  return useInfiniteData<Track>({
    queryKey: libraryTracksQueryKey(userId, queryParams as any),
    endpoint: `users/${userId}/liked-tracks`,
    defaultOrderBy: 'likes.created_at',
    defaultOrderDir: 'desc',
    ...options,
  });
}
